/**
 * How v-tooltip looks. PrimeVue runs unstyled here, and a directive has no Volt wrapper to
 * carry its classes, so without this the tooltip's text is dropped into the page unpositioned
 * - it reads as stray text wherever the page ends. Registered globally in main.js.
 *
 * PrimeVue positions the root with inline top/left; `absolute` and a z-index above dialogs
 * are what make that position mean anything.
 */
export const tooltipPt = {
    root: `absolute z-[1200] max-w-xs px-1 py-1 pointer-events-none
        [&[data-p-position=top]]:pb-1.5 [&[data-p-position=bottom]]:pt-1.5
        [&[data-p-position=left]]:pr-1.5 [&[data-p-position=right]]:pl-1.5`,
    text: `whitespace-pre-line break-words rounded-md bg-surface-800 px-2.5 py-1.5 text-xs leading-snug
        text-white shadow-md dark:bg-surface-100 dark:text-surface-900`,
    arrow: 'hidden',
}
